import { render, staticRenderFns } from "./MySchool.vue?vue&type=template&id=08c4b5a4&scoped=true&"
import script from "./MySchool.vue?vue&type=script&lang=js&"
export * from "./MySchool.vue?vue&type=script&lang=js&"
import style0 from "./MySchool.vue?vue&type=style&index=0&id=08c4b5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4b5a4",
  null
  
)

export default component.exports